<template>
    <div class="problems-budget">
        <v-form
            ref="form"
            v-model="valid"
            v-if="step === 3"
        >
            <v-card class="px-6 my-10 white-color border-transparent" outlined>
                <v-row>
                    <v-col cols="12" class="col-sm-2 pa-sm-6">
                        <span class="font-weight-medium">{{$t('culture')}}:</span>
                    </v-col>
                    <v-col cols="12" class="col-sm-10">
                        <v-tabs
                            v-model="activeTab"
                            active-class="ont-weight-bold text--main-yellow"
                            slider-color="orange lighten-2"
                            ref="tabs"
                        >
                            <v-tab
                                v-for="(item, idx) in Number(calculations)"
                                :key="idx"
                                class=" body-1 text-capitalize"
                            >{{getCultureName(idx)}}</v-tab>
                        </v-tabs>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-tabs-items
                            v-model="activeTab"
                        >
                            <culture-tab
                                v-for="(item, idx) in Number(calculations)"
                                :key="idx"
                                :calculation-idx="idx"
                                :attributes="attributes"
                                :categories="categories"
                            ></culture-tab>
                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-card>
            <div class="d-flex justify-center">
                <v-btn
                    outlined
                    dark
                    class="caption text--main-yellow mx-2 mx-md-5"
                    justify="center"
                    width="130"
                    @click="$emit('previous-step')"
                >
                    <v-icon>arrow_back</v-icon>
                    {{$t('back')}}
                </v-btn>
                <v-btn
                    v-if="valid"
                    depressed
                    class="caption  white--text main--yellow mx-2 mx-md-5"
                    :disabled="!valid"
                    @click="validate"
                >{{$t('results')}}</v-btn>
                <v-btn
                    v-if="!valid"
                    depressed
                    color="grey lighten-1"
                    class="caption mx-2 mx-md-5"
                    width="130"
                    @click="nextTab"
                >{{$t('next')}}</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import CultureTab from "./CultureTab";
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";

export default {
    name: "AttributesBudgetStep",
    components: {
        CultureTab,
    },
    mixins: [ CalculatorDataProvider, ],
    props: [ 'attributes', 'categories', 'cultures', 'step' ],
    data() {
        return {
            valid: false,
            activeTab: 0,
        }
    },
    computed: {
        calculations() {
            return this.$store.getters.calculatorFullData.length;
        }
    },
    methods: {
        getCultureName(idx) {
            const cultureId = this.getCultureId(idx);
            const culture = this.cultures.find(item => item.id === cultureId);
            return culture ? culture.cultureName : '---'
        },
        nextTab() {
            if(this.activeTab === this.calculations - 1){
                this.activeTab = 0
            } else {
                this.activeTab++
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit('next-step');
            }
        }
    }
}
</script>

<style scoped>
    @media screen and (min-width: 1900px) {
        .problems-budget {
            margin-left: 100px !important;
            margin-right: 100px !important;
        }
    }
</style>
